export const SENTRY_DSN = import.meta.env['REACT_APP_SENTRY_DSN']
